<template lang="pug">
div
  embed-text.description(:text="(module.description || '').trim() || $t('groupPages.modules.description.noDescription')", v-if="!openEditor || !edition")
  div(v-if="openEditor && edition")
    .form-group
      label {{$t("groupManagement.description.title")}}
      textarea.form-control(v-model="module.description")
    button.btn.btn-primary.pright(@click="save") {{$t('globals.save')}}
    .cf
  template(v-if='openEditor && !edition')
    .btn.btn-primary.pright(@click="toggleEdition") {{$t('globals.edit')}}
    .cf

</template>
<script>
import api from '@/utils/api'
import {success, error} from '@/components/shared/Notify'

import EmbedText from '@/components/shared/EmbedText'

export default {
  props: ['vueData', 'module', 'openEditor'],
  components: {
    EmbedText
  },
  data () {
    return {
      edition: false
    }
  },
  mounted () {
    this.edition = false
  },
  methods: {
    toggleEdition () {
      this.edition = !this.edition
    },
    save () {
      return api.put(`public/${this.vueData.group.kind}/${this.vueData.group.id}/infos`,
        {
          description: this.module.description
        }).then(() => {
          this.edition = false
          this.vueData.group.page.description = this.module.description
          return success(this._i18n.t('groupPages.notify.groupUpdated'))
        }).catch(() => {
          return error(this._i18n.t('globals.error'), 'error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageDescription.vue?ea869a06